import timePeriodList from "./time-period";

export default [...timePeriodList];
